import { compose } from 'redux';

import withCreatedRef from './HOCs/withCreatedRef';
import withMultiInputStateHandlers from './HOCs/withMultiInputStateHandlers';
import withValidateOnSelect from './HOCs/withValidateOnSelect';
import withValidateOnChange from './HOCs/withValidateOnChange';
import withInputValueOnChange from './HOCs/withInputValueOnChange';
import withMultiInputPropsOnChange from './HOCs/withMultiInputPropsOnChange';
import withSelectTriggers from './HOCs/withSelectTriggers';
import MultiInput from './MultiInput';

export default compose(
  withCreatedRef(),
  withMultiInputStateHandlers(),
  withValidateOnSelect(),
  withValidateOnChange(),
  withInputValueOnChange(),
  withMultiInputPropsOnChange(),
  withSelectTriggers({
    inputDOMSelector: '#id-multi-input-input',
  })
)(MultiInput);
